import React from 'react';
import ReactDOM from 'react-dom/client';
import 'react-modal-video/css/modal-video.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "react-modal-video/css/modal-video.css";
import "./assets/css/eventflow.css";
import "./assets/css/nsm.css"; // باید آخر باشه تا override کنه


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

